
import { Options, Vue } from 'vue-class-component';
import { useRouter, Router } from 'vue-router';
import { Button, Dialog, NavBar } from 'vant';
import { Store, useStore } from 'vuex';
import Btmbtn from '../component/bottomBtn.vue';
import QuestionList from '../component/questionList.vue';

@Options({
    components: {
        Btmbtn,
        QuestionList,
        VButton: Button,
        VNavBar: NavBar,
    },
})
export default class MobileFaq extends Vue {
    public router: Router = useRouter();
    private store: Store<any> = useStore();
    private tabs: Array<string> = ['公开问题', '我的提问'];
    private cateIndex = 0;
    private searchKey = '';
    private quesPage = 1;
    private hasSearch = false;
    private categories: Array<String> = ['全部问题', '大赛规则相关', '报名相关', '队伍相关', '赛题相关', '平台使用相关', '提交相关', '成绩相关', '其它'];
    private trimSearchKey = '';

    private tabIndex = 0;
    get hasLogin() {
        return this.store.state.loginStatus.haslogin;
    }
    private clickCategory(index: number) {
        this.cateIndex = index;
        this.router.push({ path: '/mobilePublicFaq', query: { cate: index } });
    }
    private searchQues() {
        if (this.searchKey) {
            this.hasSearch = true;
            this.quesPage = 1;
            this.trimSearchKey = this.searchKey.trim();
        }
    }
    private clearSearch() {
        this.hasSearch = false;
        this.searchKey = '';
        this.trimSearchKey = '';
        this.quesPage = 1;
    }
    private clickTab(index: number) {
        if (this.hasLogin) {
            this.tabIndex = index;
            this.clearSearch();
            return;
        }
        Dialog.confirm({
            title: '登录至腾讯云',
            message: '提问需先登录腾讯云帐号并完成个人实名认证，您尚未 登录，请登录后再继续提问',
        })
            .then(() => {
                window.location.replace(`https://console.cloud.tencent.com/taop/login?redirectUrl=${encodeURIComponent(window.location.href)}`);
            })
            .catch(() => {
                // stay the page
            });
    }
    toAsk() {
        this.router.push('/mobileAsk');
    }
}
